import React, { useEffect, useRef, useState, useCallback } from 'react';
import { LiaTimesSolid } from "react-icons/lia";
import './AlertMessage.css'; // Import a CSS file for any specific styles

const AlertMessage = ({ message, closeMessage, duration = 5000, html = false }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const alertRef = useRef(null); // Create a reference for the alert element

  const handleClose = useCallback(() => {
    setFadeOut(true);
    // Set a timeout for the slideOut animation duration
    setTimeout(() => {
      closeMessage();
      setFadeOut(false); // Reset the fadeOut state for the next message
    }, 500); // match the duration of the slideOut animation
  }, [closeMessage]);

  useEffect(() => {
    if (message) {
      // Set the initial timer for the alert
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      // Cleanup the timer on component unmount or when message changes
      return () => clearTimeout(timer);
    }
  }, [message, handleClose, duration]);

  if (!message) return null;

  return (
    <div
      ref={alertRef} // Attach the reference to the alert element
      tabIndex="-1" // Make the element focusable
      className={`alert ${message.type === "success" ? "alert-success" :
        message.type === "error" ? "alert-danger" :
          message.type === "warning" ? "alert-warning" :
            message.type === "info" ? "alert-info" : ""
        } alert-toast ${fadeOut ? 'fade-out' : ''}`}
      style={{ zIndex: 999999999 }}
    >
      <button
        type="button"
        className="close"
        aria-label="Close"
        onClick={handleClose}
      >
        <LiaTimesSolid />
      </button>
      {html
        ?
        <div
          className="alert-text"
          dangerouslySetInnerHTML={{ __html: message.text }}
        />
        :
        <div className="alert-text">{message.text}</div>
      }
    </div>
  );
};

export default AlertMessage;
